import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

import * as api from '../../api/api';

class RunCommandModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            command: "start"
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleOkButtonClick = this.handleOkButtonClick.bind(this);
    }

    handleChange(event) {
        this.setState({ command: event.target.value });
    }

    handleOkButtonClick() {

        this.props.updateLoader({
            loaded: false,
            message: ""
        });

        api.makeRequest(api.runDisplayCommand(
            this.props.displayId,
            this.state.command)).then(
                (response) => {
                    this.props.updateLoader({
                        loaded: true,
                        message: ""
                    });
                },
                (error) => {
                    this.props.updateLoader({
                        loaded: true,
                        message: "Ошибка при выполнении команды: " + error
                    });
                }
            );
    }

    render() {
        return (
            <div className="modal fade" id="runCommandModal" tabIndex="-1" role="dialog" aria-labelledby="runCommandModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="runCommandModalLabel">Выполнить команду</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <select className="form-control" value={this.state.command} onChange={this.handleChange}>
                                <option value="start">Запуск</option>
                                <option value="stop">Остановка</option>
                                <option value="restart">Перезапуск</option>
                            </select>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Отмена</button>
                            <button type="button" className="btn btn-primary-custom" data-dismiss="modal" onClick={this.handleOkButtonClick}>Выполнить</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RunCommandModal;